import { IChannel } from '../models/ichannel';
import { IChartContext, IPoint, IStepViewModel } from '../models/interfaces';
import { line as d3Line } from 'd3-shape';

export class StepViewModel implements IStepViewModel {
    // data members

    path;
    titleY: number;
    title: string;

    // constructor

    constructor(chartContext: IChartContext, channel: IChannel | null) {
        let points = new Array<IPoint>();
        points.push({ x: -15, y: chartContext.leadHeight / 2 });
        points.push({ x: -10, y: chartContext.leadHeight / 2 });

        points.push({ x: -10, y: chartContext.leadHeight / 2 });
        points.push({ x: -10, y: chartContext.leadHeight / 2 - 10 });

        points.push({ x: -10, y: chartContext.leadHeight / 2 - 10 });
        points.push({ x: -5, y: chartContext.leadHeight / 2 - 10 });

        points.push({ x: -5, y: chartContext.leadHeight / 2 - 10 });
        points.push({ x: -5, y: chartContext.leadHeight / 2 });

        points.push({ x: -5, y: chartContext.leadHeight / 2 });
        points.push({ x: 0, y: chartContext.leadHeight / 2 });

        let line = d3Line<IPoint>()
            .x((point: IPoint) => {
                return point.x;
            })
            .y((point: IPoint) => {
                return point.y;
            });

        this.path = line(points);

        this.title = channel?.name ?? '';
        this.titleY = chartContext.leadHeight / 2 + 5;
    }
}
